function SvgMonitoring(props) {
  return (
    <svg height="1em" viewBox="0 0 24 24" width="1em" {...props}>
      <defs>
        <path d="M0 .006h23.04v20.058H0z" id="monitoring_svg__a" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <g transform="translate(.096 1.175)">
          <mask fill="#fff" id="monitoring_svg__b">
            <use xlinkHref="#monitoring_svg__a" />
          </mask>
          <path
            d="M22.09 18.652c-.269.44-.747.701-1.28.701H2.23a1.483 1.483 0 01-1.28-.701 1.35 1.35 0 01-.013-1.41l9.29-15.802c.266-.453.75-.724 1.293-.724.543 0 1.027.27 1.293.724l9.29 15.801c.261.444.257.971-.013 1.41m.661-1.758l-9.29-15.801C13.06.412 12.336.006 11.52.006c-.816 0-1.541.406-1.94 1.085L.288 16.894a2.027 2.027 0 00.02 2.117c.403.659 1.121 1.053 1.92 1.053H20.81c.8 0 1.518-.394 1.922-1.053.404-.66.41-1.451.02-2.118"
            fill="currentColor"
            mask="url(#monitoring_svg__b)"
          />
        </g>
        <path
          d="M12.857 11.74l-.417 3.831-1.658.009-.407-3.84v-1.249h2.482v1.249zm-.363 5.302c.219.179.32.406.32.719 0 .305-.098.527-.307.7-.227.186-.521.277-.9.277-.357 0-.637-.09-.853-.274-.204-.173-.298-.396-.298-.704 0-.31.1-.547.306-.722.222-.19.499-.282.846-.282.36 0 .65.094.886.286zm.703-7.227h-3.162a.339.339 0 00-.339.338v1.605c0 .012 0 .024.002.036l.441 4.16a.339.339 0 00.338.304h.001l.263-.002a1.803 1.803 0 00-.42.268c-.36.308-.544.724-.544 1.237 0 .506.18.916.537 1.218.34.289.775.436 1.294.436.534 0 .982-.146 1.33-.432.369-.303.555-.714.555-1.222 0-.516-.191-.934-.569-1.242a1.883 1.883 0 00-.447-.271l.269-.001c.173 0 .317-.131.336-.302l.452-4.15a.38.38 0 00.002-.037v-1.605a.339.339 0 00-.34-.338z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export default SvgMonitoring
